export default "__VITE_ASSET__pbOJBhHv__"